var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "back-profile",
        {
          nativeOn: {
            click: function($event) {
              return _vm.navigateTo("app.profile.home")
            }
          }
        },
        [_vm._v("Perfil de " + _vm._s(_vm.studentProfile.student.name))]
      ),
      _vm._v(" "),
      _c(
        "block",
        { staticStyle: { "padding-bottom": "60px" } },
        [
          _c("template", { slot: "header" }, [_vm._v("Comentarios")]),
          _vm._v(" "),
          _vm.studentProfile.latestComments.length
            ? _c(
                "div",
                { staticClass: "comments" },
                _vm._l(_vm.studentProfile.latestComments, function(comment) {
                  return _c(
                    "div",
                    { key: comment.id, staticClass: "comment" },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: comment.subject,
                              expression: "comment.subject"
                            }
                          ],
                          staticClass: "is-block has-text-weight-medium fs-16"
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(comment.subject) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "is-block has-text-weight-medium fs-16"
                        },
                        [
                          _vm._v(
                            _vm._s(comment.author.name) +
                              " - " +
                              _vm._s(_vm._f("humanizeDate")(comment.createdAt))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "is-size-6 is-marginless" }, [
                        _vm._v(_vm._s(comment.comment))
                      ])
                    ]
                  )
                }),
                0
              )
            : _c("p", [_vm._v("No hay comentarios registrados.")])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }